const ACL_KINDS = {
  1: { kind: 1, label: 'Default', service: 'Redis' },
  2: { kind: 2, label: 'Elasticsearch', service: 'Elasticsearch' },
  4: { kind: 4, label: 'Kibana', service: 'Elasticsearch' },
  5: { kind: 5, label: 'Cerebro', service: 'Elasticsearch' },
  6: { kind: 6, label: 'CockroachDB', service: 'CockroachDB' },
  7: { kind: 7, label: 'CockroachDB Admin UI', service: 'CockroachDB' },
  8: { kind: 8, label: 'PostgreSQL Master', service: 'PostgreSQL' },
  9: { kind: 9, label: 'PostgreSQL Replica', service: 'PostgreSQL' },
  10: { kind: 10, label: 'TimescaleDB Master', service: 'TimescaleDB' },
  11: { kind: 11, label: 'TimescaleDB Replica', service: 'TimescaleDB' },
};

export default ACL_KINDS;
